<template>
  <Head>
    <title>Add New Recipe | NutriStudents K-12</title>
    <meta name="description" content="Add New Recipe" />
  </Head>
  <default-layout>
    <BreadcrumLayout>
      <div class="flex">
        <!-- <a href="#" class="link-color"> --><U>Templates</U><!-- </a> -->
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mt-1" viewBox="0 0 20 20" fill="currentColor">
          <path fill-rule="evenodd"
            d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
            clip-rule="evenodd" />
        </svg>
        <inertia-link :href="route('recipes')" class="link-color"><U>Recipes</U></inertia-link>
      </div>
    </BreadcrumLayout>

    <form action="#" enctype="multipart/form-data">
      <PageTitleLayout>
        <div class="lg:mb-0 mb-4 w-6/12">
          <h1 class="heading-color xl:text-4xl sm:text-2xl text-base font-bold">
            Add New Recipe
          </h1>
        </div>
        <div class="w-full flex lg:flex-nowrap flex-wrap justify-end items-center">
          <button type="button">
            <inertia-link :href="route('recipes')" class="
              w-full
              inline-flex
              justify-center
              rounded-md
              font-bold
              px-4
              py-3.5
              uppercase
              bg-gray-500
              text-white
              focus:outline-none
              sm:w-40
              mx-2
            ">Cancel</inertia-link>
          </button>

          <button type="button" @click="recipe_add_save_script" class="
              menu1-background-color
              w-full
              inline-flex
              justify-center
              rounded-md
              font-bold
              px-4
              py-3.5
              uppercase
              button-color
              text-white
              focus:outline-none
              sm:ml-3 sm:w-40
              mt-3
              sm:mt-0
              mx-2
            ">
            Save
          </button>
        </div>
      </PageTitleLayout>

      <PageTitleLayout>
        <div class="lg:mb-0 mb-4 w-full">
          <h1 class="text-base text-gray-500 font-bold"></h1>
        </div>
      </PageTitleLayout>

      <PageTitleLayout>
        <div class="
            flex
            justify-between
            shadow
            py-8
            mt-4
            align-middle
            min-w-full
            bg-white
            rounded-lg
            min-height-third
          ">
          <div class="sm:w-2/5 w-full">
            <div class="xl:grid xl:gap-1 xl:grid-cols-3 block pl-5 items-center">
              <label class="font-bold text-gray-700">Recipe Name*</label>
              <div>
                <input type="text" placeholder="Name" id="recipe_name" name="recipe_name" v-model="form.recipe_name"
                  class="
                    xl:mt-0
                    mt-4
                    sm:w-64
                    w-48
                    shadow-sm
                    focus:border-none
                    block
                    sm:text-sm
                    border-gray-300
                    rounded-lg
                    select-menu-height
                    input-background
                  " />
                <div v-if="form.errors.recipe_name" class="validation_error_msg w-60">
                  {{ form.errors.recipe_name }}
                </div>
              </div>
            </div>


            <div class="xl:grid xl:gap-1 xl:grid-cols-3 block pl-5 items-center pt-6">
              <label class="font-bold text-gray-700">Simplified Name</label>
              <div>
                <input type="text" placeholder="Simplified Name" id="simplified_name" name="simplified_name"
                  v-model="form.simplified_name" class="
                    xl:mt-0
                    mt-4
                    sm:w-64
                    w-48
                    shadow-sm
                    focus:border-none
                    block
                    sm:text-sm
                    border-gray-300
                    rounded-lg
                    select-menu-height
                    input-background
                  " />
                <div v-if="form.errors.simplified_name" class="validation_error_msg w-60">
                  {{ form.errors.simplified_name }}
                </div>
              </div>
            </div>


            <div class="xl:grid xl:gap-1 xl:grid-cols-3 block pl-5 items-center pt-6" v-if="!$page.props.is_production">
              <label class="font-bold text-gray-700">Type Number</label>
              <div>
                <input type="text" placeholder="Prefix" id="prefix" name="prefix" v-model="form.prefix"
                  @input="fetchSuggestions" required class="
                    xl:mt-0
                    mt-4
                    sm:w-64
                    w-48
                    shadow-sm
                    focus:border-none
                    block
                    sm:text-sm
                    border-gray-300
                    rounded-lg
                    select-menu-height
                    input-background
                  " />
                <div v-if="form.errors.prefix" class="validation_error_msg w-60">
                  {{ form.errors.prefix }}
                </div>
                <ul v-if="showSuggestions && suggestions.length" class="suggestions">
                  <li v-for="(suggestion, index) in suggestions" :key="index" @click="selectSuggestion(suggestion)">
                    {{ suggestion }}
                  </li>
                </ul>
              </div>
              <!-- Suggestions Dropdown -->

            </div>

            <div class="
                xl:grid xl:gap-1 xl:grid-cols-3
                block
                pl-5
                pt-6
                items-center
              ">
              <label class="font-bold text-gray-700">Category*</label>
              <div class="relative pl-0 sm:w-64 w-48 lg:top-0 xl:mt-0 mt-4">
                <select id="recipe_category" name="recipe_category" v-model="form.recipe_category"
                  v-on:change="categoryChange()" class="
                    shadow-sm
                    focus:border-color
                    block
                    sm:text-sm
                    border-gray-300
                    rounded-lg
                    w-full
                    select-menu-height
                    input-background
                    text-gray-500
                  ">
                  <option value="">Select</option>
                  <option v-for="(category, index) in categories" :value="index">
                    {{ category }}
                  </option>
                </select>
                <div class="
                    absolute
                    flex
                    justify-center
                    items-center
                    searching-background-color
                    select-menu-height
                    w-9
                    text-white
                    top-0
                    right-0
                    rounded-lg rounded-tl-none rounded-bl-none
                    pointer-events-none
                  ">
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
                <div v-if="form.errors.recipe_category" class="validation_error_msg">
                  {{ form.errors.recipe_category }}
                </div>
              </div>
            </div>

            <div class="
                xl:grid xl:gap-1 xl:grid-cols-3
                block
                pl-5
                pt-6
                items-center
              ">
              <label class="font-bold text-gray-700">Yield of Recipe*</label>
              <div>
                <input type="number" id="recipe_portion" min="0" name="recipe_portion" v-model="form.recipe_portion"
                  class="
                    xl:mt-0
                    mt-4
                    w-24
                    mr-
                    shadow-sm
                    focus:border-none
                    block
                    sm:text-sm
                    border-gray-300
                    rounded-lg
                    select-menu-height
                    input-background
                  " />
                <div v-if="form.errors.recipe_portion" class="validation_error_msg w-72">
                  {{ form.errors.recipe_portion }}
                </div>
              </div>
            </div>

            <div class="
                xl:grid xl:gap-1 xl:grid-cols-3
                block
                pl-5
                pt-6
                items-center
              ">
              <label class="font-bold text-gray-700">Serving Size</label>
              <input type="text" id="recipe_serving" min="0" step="any" name="recipe_serving"
                v-model="form.recipe_serving" class="
                  xl:mt-0
                  mt-4
                  w-24
                  mr-
                  shadow-sm
                  focus:border-none
                  block
                  sm:text-sm
                  border-gray-300
                  rounded-lg
                  select-menu-height
                  input-background
                " />
              <div class="relative focus:outline-none W-48">
                <select id="recipe_serving_unit" autocomplete="" v-model="form.recipe_serving_unit" class="
                    shadow-sm
                    focus:border-none
                    block
                    sm:text-sm
                    border-gray-300
                    rounded-lg
                    w-full
                    select-menu-height
                  ">
                  <option value="">Select</option>
                  <optgroup label="Weight">
                    <option v-for="mass_measurement in mass_measurements" :value="mass_measurement.id">
                      {{ mass_measurement.name }}
                    </option>
                  </optgroup>
                  <optgroup label="Volume">
                    <option v-for="volume_measurement in volume_measurements" :value="volume_measurement.id">
                      {{ volume_measurement.name }}
                    </option>
                  </optgroup>
                  <optgroup label="Unit">
                    <option v-for="unit_measurement in unit_measurements" :value="unit_measurement.id">
                      {{ unit_measurement.name }}
                    </option>
                  </optgroup>
                  <optgroup label="Other">
                    <option v-for="unit_measurement in other_measurements" :value="unit_measurement.id">
                      {{ unit_measurement.name }}
                    </option>
                  </optgroup>
                </select>
                <div class="
                    absolute
                    flex
                    justify-center
                    items-center
                    searching-background-color
                    select-menu-height
                    w-9
                    text-white
                    top-0
                    right-0
                    rounded-lg rounded-tl-none rounded-bl-none
                    pointer-events-none
                  ">
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
              </div>
            </div>

            <div v-if="other_measurements.find((item) => item.id == form.recipe_serving_unit)" class="
                xl:grid xl:gap-1 xl:grid-cols-3
                block
                pl-5
                pt-6
                items-center
              ">
              <label class="font-bold text-gray-700"></label>

              <div><input type="text" placeholder="Name of Other Unit Type" id="serving_size_uom_other"
                  name="serving_size_uom_other" v-model="form.serving_size_uom_other"
                  class="xl:mt-0 mt-4 sm:w-64 w-48 shadow-sm focus:border-none block sm:text-sm border-gray-300 rounded-lg select-menu-height input-background"><!--v-if-->
              </div>
            </div>

            <div class="
                xl:grid xl:gap-1 xl:grid-cols-3
                block
                pl-5
                pt-6
                items-center
              ">
              <label class="font-bold text-gray-700 leading-[1.4em]">Calculated Serving Size</label>
              <b>{{ calculatedServingSize }} Gram</b>
            </div>




            <div class="xl:grid xl:gap-1 xl:grid-cols-3 block pl-5 pt-6">
              <label class="font-bold text-gray-700">Recipe Image</label>
              <div>
                <input accept="image/*" type="file" id="recipe_image" name="recipe_image" class="
                    h-9
                    xl:mt-0
                    mt-4
                    sm:w-64
                    w-48
                    shadow-sm
                    focus:border-none
                    block
                    sm:text-sm
                    border
                    p-1
                    border-gray-300
                    rounded-lg
                    input-background
                  " v-on:change="onRecipeImageChange" />

                <div v-if="recipeimage" class="relative w-20 mt-2">
                  <img :src="recipeimage" class="xl:mt-0 mt-4" width="100" height="100" />
                  <i class="fa fa-times absolute top-0 right-0" aria-hidden="true" @click="removeRecipeImage"></i>
                </div>
                <div v-if="form.errors.recipe_image" class="validation_error_msg">
                  {{ form.errors.recipe_image }}
                </div>
                <div class="loader-15" v-if="uploadProgress"></div>
              </div>
            </div>
            <div class="xl:grid xl:gap-1 xl:grid-cols-3 block pl-5 pt-6 items-center">
              <label class="font-bold text-gray-700">Favorite</label>
              <div>
                <input type="checkbox" id="recipe_portion" name="recipe_portion" v-model="form.is_favorite">
              </div>
            </div>
          </div>

          <div class="sm:w-6/12 w-full">
            <div class="flex justify-between items-center pl-5">
              <label class="font-bold text-gray-700">Cooking Instructions*</label>
            </div>
            <div>
              <div class="border-gray-300 bg-gray-100 mt-2 ml-4 mr-4">
                <textarea id="recipe_instructions" name="recipe_instructions" v-model="form.recipe_instructions"
                  style="display: none"></textarea>
                <quill-editor theme="snow" toolbar="minimal" style="height: 250px"
                  id="quill_editor_instructions"></quill-editor>
              </div>
              <div v-if="form.errors.recipe_instructions" class="validation_error_msg pl-4">
                {{ form.errors.recipe_instructions }}
              </div>
            </div>

            <div class="w-96-edit-recipes flex justify-start pl-4 pt-4">
              <!-- <div class="flex justify-between items-center pr-5">
                                <label class="font-bold text-gray-700">HACCP</label>
                            </div>  -->

              <div class="relative focus:outline-none xl:w-40 w-72 mr-3">
                <select id="recipe_haccp_type" name="recipe_haccp_type" autocomplete="recipe_haccp_type"
                  v-model="form.recipe_haccp_type" class="
                    shadow-sm
                    focus:border-none
                    block
                    sm:text-sm
                    border-gray-300
                    rounded-lg
                    w-full
                    select-menu-height
                  " @change="getHaccpNames($event)">
                  <option value="">HACCP Type</option>
                  <option v-for="haccp_type in haccp_types" :value="haccp_type.type">
                    {{ haccp_type.type }}
                  </option>
                </select>
                <div class="
                    absolute
                    flex
                    justify-center
                    items-center
                    searching-background-color
                    select-menu-height
                    w-9
                    text-white
                    top-0
                    right-0
                    rounded-lg rounded-tl-none rounded-bl-none
                    pointer-events-none
                  ">
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
              </div>
              <div class="relative focus:outline-none xl:w-40 w-72 mr-3">
                <select id="recipe_haccp_name" name="recipe_haccp_name" autocomplete="recipe_haccp_name"
                  v-model="form.recipe_haccp_id" class="
                    shadow-sm
                    focus:border-none
                    block
                    sm:text-sm
                    border-gray-300
                    rounded-lg
                    w-full
                    select-menu-height
                  ">
                  <option value="">Name of Rule</option>
                  <option v-for="haccp_name in haccp_names" :value="haccp_name.id">
                    {{ haccp_name.name }}
                  </option>
                </select>
                <div class="
                    absolute
                    flex
                    justify-center
                    items-center
                    searching-background-color
                    select-menu-height
                    w-9
                    text-white
                    top-0
                    right-0
                    rounded-lg rounded-tl-none rounded-bl-none
                    pointer-events-none
                  ">
                  <i class="fa fa-sort-desc" aria-hidden="true"></i>
                </div>
              </div>

              <button type="button" class="
                  w-42
                  inline-flex
                  justify-center
                  items-center
                  rounded-md
                  font-bold
                  px-4
                  py-2
                  uppercase
                  menu1-background-color
                  text-white
                  focus:outline-none
                  mr-3
                " @click="updateHaccpDataIntoCookingInstructions">
                ADD HACCP
              </button>
            </div>
          </div>
        </div>
      </PageTitleLayout>

      <header class="
          mx-8
          searching-background-color
          flex
          justify-between
          items-center
          py-2
          pl-6
          shadow
          overflow-hidden
          rounded-t-lg
          mt-8
        ">
        <h2 class="text-white text-lg font-bold w-11/12  flex gap-2 items-center">Ingredients <a @click="toggleFrection()"
            class="text-white text-lg font-bold w-11/12 " href="javascript:void(0)">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
              stroke="currentColor" :class="{ 'text-[#39b54a]': is_frection }" class="w-6 h-6 ">
              <path stroke-linecap="round" stroke-linejoin="round"
                d="M9.75 3.104v5.714a2.25 2.25 0 0 1-.659 1.591L5 14.5M9.75 3.104c-.251.023-.501.05-.75.082m.75-.082a24.301 24.301 0 0 1 4.5 0m0 0v5.714c0 .597.237 1.17.659 1.591L19.8 15.3M14.25 3.104c.251.023.501.05.75.082M19.8 15.3l-1.57.393A9.065 9.065 0 0 1 12 15a9.065 9.065 0 0 0-6.23-.693L5 14.5m14.8.8 1.402 1.402c1.232 1.232.65 3.318-1.067 3.611A48.309 48.309 0 0 1 12 21c-2.773 0-5.491-.235-8.135-.687-1.718-.293-2.3-2.379-1.067-3.61L5 14.5" />
            </svg>

          </a></h2>

        <a href="#" @click="addIngredientRecipeModalOpen">
          <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-white mr-3" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
        </a>
      </header>
      <div class="mx-8 flex flex-col mb-6">
        <div class="overflow-x-auto">
          <div class="align-middle inline-block min-w-full">
            <div class="
                shadow
                overflow-hidden
                border-b-2 border-gray-200
                sm:rounded-lg
              ">
              <draggable class="list-group" v-if="rec_ingredients.length" :list="rec_ingredients" tag="table"
                item-key="id">
                <template #header>
                  <thead class="bg-gray-50" slot="header">
                    <tr>
                      <th scope="col">&nbsp;</th>
                      <th scope="col" class="
                        px-6
                        py-3
                        text-left text-base
                        font-bold
                        text-black-800
                        uppercase
                        tracking-wider
                      ">
                        INGREDIENT
                      </th>

                      <th scope="col" class="
                        px-6
                        py-3
                        text-left text-base
                        font-bold
                        text-black-800
                        uppercase
                        tracking-wider
                      ">
                        RECIPE AMOUNT*
                      </th>

                      <th scope="col" class="
                        px-6
                        py-3
                        text-left text-base
                        font-bold
                        text-black-800
                        uppercase
                        tracking-wider
                      ">
                        SERVING AMOUNT*
                      </th>

                      <th scope="col" class="
                        px-6
                        py-3
                        text-left text-base
                        font-bold
                        text-black-800
                        uppercase
                        tracking-wider
                      ">
                        MMA   <p class="lowercase">(oz eq)</p>
                      </th>

                      <th scope="col" class="
                        px-6
                        py-3
                        text-left text-base
                        font-bold
                        text-black-800
                        uppercase
                        tracking-wider
                      ">
                        GRA <p class="lowercase">(oz eq)</p>
                      </th>

                      <th scope="col" class="
                        px-6
                        py-3
                        text-left text-base
                        font-bold
                        text-black-800
                        uppercase
                        tracking-wider
                      ">
                        FRU <p class="lowercase">(cups)</p>
                      </th>

                      <th scope="col" class="
                        px-6
                        py-3
                        text-left text-base
                        font-bold
                        text-black-800
                        uppercase
                        tracking-wider
                      ">
                        MLK <p class="lowercase">(cups)</p>
                      </th>

                      <th scope="col" class="
                        px-6
                        py-3
                        text-left text-base
                        font-bold
                        text-black-800
                        uppercase
                        tracking-wider
                      ">
                        VEG <p class="lowercase">(cups)</p>
                      </th>

                      <th scope="col" class="
                        px-6
                        py-3
                        text-left text-base
                        font-bold
                        text-black-800
                        uppercase
                        tracking-wider
                      ">
                        DG <p class="lowercase">(cups)</p>
                      </th>

                      <th scope="col" class="
                        px-6
                        py-3
                        text-left text-base
                        font-bold
                        text-black-800
                        uppercase
                        tracking-wider
                      ">
                        R/O <p class="lowercase">(cups)</p>
                      </th>

                      <th scope="col" class="
                        px-6
                        py-3
                        text-left text-base
                        font-bold
                        text-black-800
                        uppercase
                        tracking-wider
                      ">
                        BPL <p class="lowercase">(cups)</p>
                      </th>

                      <th scope="col" class="
                        px-6
                        py-3
                        text-left text-base
                        font-bold
                        text-black-800
                        uppercase
                        tracking-wider
                      ">
                        STAR <p class="lowercase">(cups)</p>
                      </th>

                      <th scope="col" class="
                        px-6
                        py-3
                        text-left text-base
                        font-bold
                        text-black-800
                        uppercase
                        tracking-wider
                      ">
                        OTHER <p class="lowercase">(cups)</p>
                      </th>

                      <th scope="col" class="
                        px-6
                        py-3
                        text-left text-base
                        font-bold
                        text-black-800
                        uppercase
                        tracking-wider
                      "></th>
                    </tr>
                  </thead>

                </template>

                <template #item="{ element, index }">
                  <tbody>
                    <recipe-ingredients :recipe_portion="this.form.recipe_portion" :ingredient="element" :key="element.id"
                      :ref="'recipe_' + index" :recipe="recipe"
                      @onIngredientDelete="addIngredientsDeleteScript(element.id, index)"
                      @getDataRecipeIngredient="getDataRecipeIngredient(index, $event)"
                      @updateOptionalComponentsParent="updateOptionalComponentsParent(index, $event)"
                      :recipe_category="form.recipe_category" :is_frection="is_frection"
                      @toggleFrection="toggleFrection()" />
                  </tbody>
                </template>
              </draggable>
              <!-- </table> -->
            </div>
          </div>
        </div>
      </div>

      <div class="mx-8 text-sm italic">^ Measurements are provided by the USDA</div>

      <header class="
          searching-background-color
          flex
          justify-between
          items-center
          py-2
          pl-6
          shadow
          overflow-hidden
          rounded-t-lg
          mx-8
          mt-8
        ">
        <h2 class="text-white text-lg font-bold w-10/12 flex items-center  ">Calculated Totals (1 serving)

           <button type="button" @click="toggleCalculatedTotals()" class="focus:outline-none ml-2 " :class="{'text-green-500': form.is_calculation_total_override, 'text-white': !form.is_calculation_total_override}">
            <svg  xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 20 20" fill="currentColor"><path data-v-61ec44f1="" fill-rule="evenodd" d="M18 8a6 6 0 01-7.743 5.743L10 14l-1 1-1 1H6v2H2v-4l4.257-4.257A6 6 0 1118 8zm-6-4a1 1 0 100 2 2 2 0 012 2 1 1 0 102 0 4 4 0 00-4-4z" clip-rule="evenodd"></path></svg>
          </button>
        </h2>



      </header>

      <div class="flex flex-col mb-6 mx-6">
        <div class="overflow-x-auto">
          <div class="align-middle inline-block min-w-full">
            <div class="
                shadow
                overflow-hidden
                border-b-2 border-gray-200
                sm:rounded-lg
              ">
              <calculated-totals-component :sum_products_totals="calculated_totals_sum"
              :form="form" @removeCalculationTotalOverride="removeCalculationTotalOverride" @setCalculationTotalOverride="setCalculationTotalOverride" :null_nutrient="null_nutrient"
              />
            </div>
          </div>
        </div>
        
        <div class="mt-4 "><b>* includes null values</b> </div>
        <div class="mt-1 "><b>**% of Calories from</b> </div>
      </div>

      <header
        class="searching-background-color flex justify-between items-center py-2 pl-6 shadow overflow-hidden rounded-t-lg  mx-6 mt-8">
        <h2 class="text-white text-lg font-bold w-11/12">Allergen Warnings</h2>
      </header>

      <TableIndexLayout>
        <div class="-my-2">
          <div class="py-2 align-middle inline-block  px-6 w-full">
            <div class="shadow overflow-x-auto">
              <table class="min-w-full">

                <tbody>
                  <!-- Odd row -->

                  <tr v-if="!allergens.length" class="bg-white">
                    <td class="px-6 py-4 whitespace-nowrap text-base text-color text-left" colspan="7"><b
                        class="text-black">None</b></td>
                  </tr>


                  <tr v-else v-for="(iproduct, index) in allergens"
                    :class="{ 'bg-white': index % 2 == 0, 'tr-background-color': index % 2 != 0 }">

                    <td class="px-6 py-4 whitespace-nowrap text-base font-medium text-color ">
                      <b class="text-black"> {{ iproduct.name }}: </b>{{
                        iproduct.preferred_product_information.allergens_name }}
                    </td>
                    <td class="px-6 py-4 whitespace-nowrap id-color text-xl font-extrabold text-right">
                      <a :href="route('ingredients-edit', { id: iproduct.id })" class="" target="_blank"><i
                          class="fa fa-external-link pr-3" aria-hidden="true"></i></a>
                    </td>
                  </tr>


                </tbody>
              </table>
            </div>
          </div>
        </div>

      </TableIndexLayout>

      <div class="
          w-full
          flex
          lg:flex-nowrap
          flex-wrap
          justify-end
          items-center
          mb-6
          px-8
        ">
        <button type="button">
          <inertia-link :href="route('recipes')" class="
            w-full
            inline-flex
            justify-center
            rounded-md
            font-bold
            px-4
            py-2
            uppercase
            bg-gray-500
            text-white
            focus:outline-none
            sm:w-40
          ">Cancel</inertia-link>
        </button>

        <button type="button" @click="recipe_add_save_script" class="
            menu1-background-color
            w-full
            inline-flex
            justify-center
            rounded-md
            font-bold
            px-4
            py-2
            uppercase
            button-color
            text-white
            focus:outline-none
            sm:ml-3 sm:w-40
            mt-3
            sm:mt-0
          ">
          Save
        </button>
      </div>
    </form>
  </default-layout>

  <jet-dialog-modal :show="addIngredientsModal" @close="addIngredientsModal = false">
    <template #title>
      <div class="flex justify-between items-center">
        <div class="relative">
          <label  class="text-lg font-bold block">
          Search ingredients to Add/Attach with recipe 
          </label >

          <p class="text-gray-500 text-sm italic mt-1">
          To ensure an accurate Nutrient Analysis, please add your Ingredients in an “as consumed” form (Ex. Pasta, cooked vs. Pasta, dry) 
          </p>
        </div>

        <div class="relative md:w-56">
          <input class="
              border-2 border-gray-300
              bg-white
              h-10
              px-3
              pr-10
              rounded-lg
              text-sm
              focus:outline-none
              w-full
            " type="search" name="search_term" placeholder="Search" v-model="search_term"
            @keyup.enter="ingredientSearchScriptModal" />
          <button type="button" class="absolute right-0 top-0 mt-2 mr-4 outline-none"
            @click="ingredientSearchScriptModal">
            <i class="fa fa-search" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </template>

    <template #content>
      <TableIndexLayout>
        <div class="-my-2">
          <div class="py-2 align-middle inline-block px-2 w-full">
            <div class="shadow overflow-x-auto max-height">
              <table class="min-w-full">
                <thead class="header-bg-color">
                  <tr>
                    <th scope="col" class="
                        px-6
                        py-3
                        text-left text-base
                        font-bold
                        text-black-800
                        uppercase
                        tracking-wider
                      ">
                      INGREDIENT NAME
                    </th>
                    <th scope="col" class="
                        px-6
                        py-3
                        text-left text-base
                        font-bold
                        text-black-800
                        uppercase
                        tracking-wider
                      "></th>
                  </tr>
                </thead>
                <tbody>
                  <!-- Odd row -->
                  <tr v-if="!searched_ingredients.length" class="bg-white">
                    <td class="
                        px-6
                        py-4
                        whitespace-nowrap
                        text-base text-color text-center
                      " colspan="7">
                      No Ingredient Found
                    </td>
                  </tr>

                  <tr v-for="(ingredient, index) in searched_ingredients" :class="{
                    'bg-white': index % 2 == 0,
                    'tr-background-color': index % 2 != 0,
                  }" class="cursor-pointer" @click="addIngredientAddScript(ingredient, index)">
                    <td class="
                        px-6
                        py-4
                        whitespace-nowrap
                        text-base text-color
                        td-background-color
                      ">
                      <div class="tooltip">
                        <div class="trim_text">{{ ingredient.name }}</div>
                        <div class="top">
                          {{ ingredient.name }}
                          <i></i>
                        </div>
                      </div>
                    </td>

                    <td class="
                        px-6
                        py-4
                        whitespace-nowrap
                        id-color
                        text-xl
                        font-extrabold
                        float-right
                      ">
                      <a :href="route('ingredients-edit', { id: ingredient.id })" class="" target="_blank"><i
                          class="fa fa-external-link pr-3" aria-hidden="true"></i></a>

                      <button type="button">
                        <i class="fa fa-plus pr-3" aria-hidden="true"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </TableIndexLayout>
    </template>

    <template #footer>
      <jet-secondary-button @click="addIngredientsModal = false">Close</jet-secondary-button>
    </template>
  </jet-dialog-modal>

  <jet-dialog-modal :show="showOverrideModal" @close="showOverrideModal = false">
    <template #title>
      <div class="flex justify-between items-center">
        <div class="relative">
          <label  class="text-lg font-bold block">
          Override Nutrition Values?
          </label > 
        </div> 
      </div>
    </template>

    <template #content>
      <TableIndexLayout>
        <div class="-my-2">
          <div class="mx-auto p-6 bg-white border border-gray-300 rounded-lg shadow-md"> 
            <!-- Warning Message --> 
             <p class="text-sm text-red-600 font-semibold mb-4"> Warning: <span class="font-normal text-gray-800">You are about to override the calculated nutrient value of this recipe.</span> </p> 
             <!-- Action Info --> 
              <p class="text-center text-gray-800 mb-6"> This action should <span class="font-semibold">only</span> be done for USDA standardized recipes with known nutrient values. </p> 
              <!-- Checkbox --> 
               <label class="flex items-start space-x-2"> 
                <input type="checkbox" class="mt-1 h-4 w-4 text-blue-600 border-gray-300 rounded focus:ring-blue-500" v-model="override_nutrients_acknowledged" /> 
                <span class="text-sm text-gray-700"> I understand this will replace all calculated values with manually entered data </span> 
              </label> 
              </div>
        </div>
      </TableIndexLayout>
    </template>

    <template #footer>
      <button @click="showOverrideModal = false" class="bg-white border border-gray-300 rounded-md text-gray-700 w-42 inline-flex justify-center items-center font-bold px-4 py-1.5 uppercase focus:outline-none disabled:opacity-50">Close</button>

      <button @click="overrideNutrients()" :disabled="!override_nutrients_acknowledged" class="ml-3 w-42 inline-flex justify-center items-center rounded-md font-bold px-4 py-1.5 uppercase menu1-background-color text-white focus:outline-none disabled:opacity-50">Confirm Override</button>
    </template>
  </jet-dialog-modal>
</template>
<script>
import DefaultLayout from "@/Layouts/DefaultLayout";
import Welcome from "@/Jetstream/Welcome";
import BreadcrumLayout from "@/Pages/Common/Breadcrumbs";
import PageTitleLayout from "@/Pages/Common/PageTitle";
import TableFilterLayout from "@/Pages/Common/TableFilters";
import TableIndexLayout from "@/Pages/Common/TableIndex";
import JetButton from "@/Jetstream/Button";
import JetSecondaryButton from "@/Jetstream/SecondaryButton";
import JetDialogModal from "@/Jetstream/DialogModal";

import RecipeIngredients from "@/Pages/Recipes/RecipeIngredients";
import CalculatedTotalsComponent from "@/Pages/Recipes/Partials/CalculatedTotalsComponent";

import HtmlEditButton from 'quill-html-edit-button';
import draggable from "vuedraggable";

export default {
  props: [
    "haccp_types",
    "mass_measurements",
    "volume_measurements",
    "unit_measurements",
    "other_measurements",
    "categories",
    "prefixes"
  ],
  components: {
    DefaultLayout,
    Welcome,
    BreadcrumLayout,
    PageTitleLayout,
    TableFilterLayout,
    TableIndexLayout,
    JetButton,
    JetSecondaryButton,
    JetDialogModal,
    RecipeIngredients,
    CalculatedTotalsComponent,
    draggable
  },

  setup: () => {
    const modules = {
      name: 'htmlEditButton',
      module: HtmlEditButton,
      options: {/* options */ }
    }
    return { modules }
  },

  data() {
    return {
      null_nutrient: [],
      is_frection: false,
      rec_ingredients: [],
      ing_prefer_products: [],
      calculated_totals_sum: [],
      recipe: { is_tenant_admin: true },

      addIngredientsModal: false,
      showOverrideModal: false,
      override_nutrients_acknowledged: false,
      recipeimage: "",
      search_term: "",
      searched_ingredients: "",
      haccp_names: "",
      haccp_description: "",
      uploadProgress: false,
      allergens: [],

      showSuggestions: false,
      suggestions: [],

      form: this.$inertia.form({

        is_the_milk_flavored : '',
          milk_fat_content : '',
          is_the_recipe_juice : '',
          is_whole_grains_info : '',
          is_whole_grains_dessert : '',


        is_calculation_total_override: false,
        calculation_total_override: null,
        prefix: "",
        recipe_name: "",
        recipe_category: "",
        recipe_portion: "",
        recipe_serving: "",
        recipe_serving_unit: "",
        serving_size_uom_other: '',
        recipe_image: "",
        recipe_instructions: "",
        recipe_haccp_type: "",
        recipe_haccp_id: "",
        attached_ingredients: [],
        is_favorite: false,
        simplified_name: null
      }),
    };
  },

  computed: {

calculatedServingSize() {
        console.log('calculatedServingSize', this.rec_ingredients);
        let ss = [];
        if (this.rec_ingredients.length > 0) {
          for (let i = 0; i < this.rec_ingredients.length; i++) {
            if (this.rec_ingredients[i].serving_amount) {
              let convertedAmount = this.changeServingAmountUom(
                'Gram',
                this.rec_ingredients[i].serving_amount_uom,
                this.rec_ingredients[i]
              );

              if (!isNaN(convertedAmount)) {
                ss.push(convertedAmount);
              }
            }
          }
        }
        return Math.round(ss.reduce((sum, value) => sum + parseFloat(value), 0));
      }
},

  methods: {

    overrideNutrients() {
        // this.is_frection = true;
        this.toggleCalculatedTotalsFinal();
        this.claseOverrideNutrients();
      },
      claseOverrideNutrients() {
        this.override_nutrients_acknowledged = false;
        this.showOverrideModal = false;
      },

    toggleCalculatedTotalsFinal() {
        this.form.is_calculation_total_override = !this.form.is_calculation_total_override;
        if (!this.form.is_calculation_total_override) {
          this.form.calculation_total_override ={};
          this.form.is_the_milk_flavored = '';
          this.form.milk_fat_content = '';
          this.form.is_the_recipe_juice = '';
          this.form.is_whole_grains_info = '';
          this.form.is_whole_grains_dessert = '';
        }
      },
      toggleCalculatedTotals() {
        // this.form.is_calculation_total_override = !this.form.is_calculation_total_override;
        if (this.form.is_calculation_total_override) {
          this.form.calculation_total_override ={};
          this.form.is_the_milk_flavored = '';
          this.form.milk_fat_content = '';
          this.form.is_the_recipe_juice = '';
          this.form.is_whole_grains_info = '';
          this.form.is_whole_grains_dessert = '';
          this.form.is_calculation_total_override = !this.form.is_calculation_total_override;
        } else {
          this.showOverrideModal = true;
        }
      },
      setCalculationTotalOverride(name, value) {
        if (!this.form.calculation_total_override) {
          this.form.calculation_total_override = {};
        }
        this.form.calculation_total_override[name] = value;
      },
      removeCalculationTotalOverride(name) {
        if (this.form?.calculation_total_override) {
          delete this.form.calculation_total_override[name];
        }
      },

    selectedCustomUnitOfMeasurement(recipe_amount_uom, cuoms) {
        return cuoms?.find((cuom) => cuom.description1 === recipe_amount_uom);
      },

      changeServingAmountUom(newUom, oldUom, ing) {


        console.log("calculatedServingSize ss Start", newUom, oldUom, ing);

        if (ing.serving_amount === null) return;

        const ppi = ing.preferred_product_information;
          let weight = ppi.nutrition_facts_weight;
          let weightUom = ppi.nutrition_facts_weight_uom;

          if (weight < 0) {
            weight = ppi.serving_component_weight;
            weightUom = ppi.serving_component_weight_uom;
          }

          console.log('changeServingAmountUom', weight, weightUom);

          if(weight <= 0){
            return 0;
          }

          

        let newServingAmount = null;

        const newUomType = this.$helpers.uomType(newUom);



        let cuom = null;
        let cuoms = [];
        if (ing.preferred_product_information?.cuom?.length > 0) {
          cuom = this.selectedCustomUnitOfMeasurement(oldUom, ing.preferred_product_information?.cuom);
          if (cuom) {
            cuoms.push(cuom);
          }
        }

        console.log("calculatedServingSize ss cuom", cuom);
        console.log("calculatedServingSize ss oldUom ", oldUom);

        if (ing.serving_amount_custom_uom && ing.serving_amount_custom_uom != '' && cuom) {
          oldUom = ing.serving_amount_custom_uom;
        }

        // console.log("calculatedServingSize ss oldUom", oldUom, ing.serving_amount_custom_uom);

        const oldUomType = this.$helpers.uomType(oldUom);

        let initAmount = ing.serving_amount;

        console.log("calculatedServingSize ss in newUomType", newUomType, oldUomType, newUom, oldUom);

        if (newUomType === 'Weight') {
          newServingAmount = this.$conversions.weight(initAmount, oldUom, newUom);
        }

        if (newUomType === 'Volume') {
          newServingAmount = this.$conversions.volume(initAmount, oldUom, newUom);
        }

        if (newUomType === 'Unit') {
          newServingAmount = initAmount;
        }

        if (newUomType === 'Weight' && oldUomType === 'Volume') {
          newServingAmount = this.$conversions.volumeToWeight(ing.preferred_product_information, ing.serving_amount, oldUom, newUom, cuoms);
          // console.log("serving_amount_uom  Weight Volume", newServingAmount);
        }

        if (newUomType === 'Volume' && oldUomType === 'Weight') {
          newServingAmount = this.$conversions.weightToVolume(ing.preferred_product_information, initAmount, oldUom, newUom, cuoms);
        }

        if (oldUomType === 'Unit' && newUomType === 'Weight' && cuom) {
          newServingAmount = ing.serving_amount * (cuom.weight / cuom.unit_amount);
          if (newUom != cuom.weight_units) {
            newServingAmount = this.$conversions.weight(newServingAmount, cuom.weight_units, newUom);
          }
        }  else if (oldUomType === 'Unit' && newUomType === 'Weight') {
          
          const unit = ppi.nutrition_facts_unit > 0 ? ppi.nutrition_facts_unit : ppi.serving_component_unit;

          

          if (weight > 0 && unit > 0) {
            let amount = ing.serving_amount * (weight / unit);
            newServingAmount = newUom !== weightUom
              ? this.$conversions.weight(amount, weightUom, newUom)
              : amount;
          }
        }

        return newServingAmount;
      },

    // Handle suggestion selection
    selectSuggestion(suggestion) {
      this.form.prefix = suggestion;
      this.showSuggestions = false;
    },
    fetchSuggestions() {
      if (this.form.prefix.length > 0) {
        // Example static list for demonstration. Replace with an API call.
        const availablePrefixes = this.prefixes;
        // Filter suggestions based on input
        this.suggestions = availablePrefixes.filter((item) =>
          item.toLowerCase().startsWith(this.form.prefix.toLowerCase())
        );
        if (this.suggestions.length > 0) this.showSuggestions = true
      } else {
        this.suggestions = [];
      }
    },
    transformToUppercase() {
      this.form.prefix = this.form.prefix.toUpperCase().slice(0, 4);
    },
    toggleFrection() {
      this.is_frection = !this.is_frection;
    },
    logChange() {
      console.log('logChange', this.rec_ingredients);
    },
    categoryChange() {
      this.rec_ingredients.forEach((value, index) => {
        this.$refs['recipe_' + index].handleChangeServingAmount();
      });
      // let isMilk = this.form.recipe_category == 'Milk' ? true : false;
      // this.calculated_totals_sum = this.$helpers.preferProductsCalculatedTotals(this.rec_ingredients, isMilk);
    },
    changeComponentVals(update_prefer_prod) {
      //console.log(update_prefer_prod);
      let isMilk = this.form.recipe_category == 'Milk' ? true : false;
      this.calculated_totals_sum = this.$helpers.preferProductsCalculatedTotals(update_prefer_prod, isMilk);

      this.null_nutrient =this.$helpers.getUniqueNullNutritionKeysRecipe(update_prefer_prod);
      
      this.getAllergen();
    },
    getAllergen(product) {
      this.allergens = [];
      this.rec_ingredients.forEach((value, index) => {
        console.log("value", value);
        if (value.preferred_product_information && value.preferred_product_information.allergens_name && value.preferred_product_information.allergens_name != '') {
          console.log("allergens_name", value.preferred_product_information.allergens_name);
          this.allergens.push(value);
        }
      });
    },

    updateOptionalComponentsParent(index, event) {

      if (event != undefined) {
        let event_val = event[0];
        let optional_type = "optional_" + event_val["type"];
        let type = event_val["type"];

        if (!isNaN(event_val["value"]) && isFinite(event_val["value"])) {
          this.rec_ingredients[index][optional_type] = event_val["value"];
        } else {
          this.rec_ingredients[index][optional_type] =
            this.rec_ingredients[index][type];
        }
      } else {
        //console.log(this.rec_ingredients);

        this.rec_ingredients[index]["optional_component_mma"] = null;
        this.rec_ingredients[index]["optional_component_wgr"] = null;
        this.rec_ingredients[index]["optional_component_fru"] = null;
        this.rec_ingredients[index]["optional_component_mlk"] = null;
        this.rec_ingredients[index]["optional_component_veg"] = null;
        this.rec_ingredients[index]["optional_component_dg"] = null;
        this.rec_ingredients[index]["optional_component_ro"] = null;
        this.rec_ingredients[index]["optional_component_leg"] = null;
        this.rec_ingredients[index]["optional_component_star"] = null;
        this.rec_ingredients[index]["optional_component_other"] = null;
      }

      console.log("updateOptionalComponentsParent", this.rec_ingredients[index], index, event);

      this.changeComponentVals(this.rec_ingredients);
      //console.log(this.rec_ingredients);
    },

    onRecipeImageChange(e) {
      let img_file = e.target.files || e.dataTransfer.files;
      if (!img_file.length) {
        return;
      } else {
        let sizes = Math.round(img_file[0].size / 1024);
        if (sizes <= 4096) {
          // this.$toast.error("This is righht image");
          // this.form.recipe_image = e.target.files[0];

          this.uploadProgress = true;
          let $this = this;

          Vapor.store(e.target.files[0], {
            visibility: 'public-read',
            progress: (progress) => { },
          }).then((response) => {
            $this.createRecipeImage(img_file[0]);
            $this.uploadProgress = false;
            $this.form.recipe_image = response;
            console.log("vapor response", response);
            // axios.post('/api/profile-photo', {
            //     uuid: response.uuid,
            //     key: response.key,
            //     bucket: response.bucket,
            //     name: this.$refs.file.files[0].name,
            //     content_type: this.$refs.file.files[0].type,
            // })
          });
          // e.target.value = '';
        } else {
          this.$toast.error(
            "Error: The size limit for images is 4MB. Please reduce the file size and try again."
          );
          e.target.value = "";
        }
        console.log(
          "File " +
          img_file[0].name +
          " is " +
          "sizes = " +
          sizes +
          " = " +
          img_file[0].size +
          " bytes in size"
        );
      }

      //console.log(e.target.files[0]);
      // this.form.recipe_image = e.target.files[0];
      // let img_file = e.target.files || e.dataTransfer.files;
      // if (!img_file.length)
      //     return;
      // this.createRecipeImage(img_file[0]);
    },

    createRecipeImage(file) {
      let reader = new FileReader();
      let vm = this;
      reader.onload = (e) => {
        vm.recipeimage = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    removeRecipeImage() {
      this.form.recipe_image = "";
      this.recipeimage = "";
      document.querySelector("#recipe_image").value = "";
    },

    getHaccpNames(event) {
      let type = event.target.value;
      if (type != "") {
        axios
          .post("/get-recipe-haccps-names", { type: type })
          .then((response) => {
            this.haccp_names = response.data;
          })
          .catch((error) => console.error(error));
      }
    },

    updateHaccpDataIntoCookingInstructions() {
      if (this.form.recipe_haccp_id == "") {
        this.$toast.error("Error: HACCP value required!");
      } else {
        axios
          .post("/get-haccp-description-cooking-instructions", {
            haccp: this.form.recipe_haccp_id,
          })
          .then((response) => {
            this.haccp_description = response.data;
            var quill_editor_set = document.querySelector(
              "#quill_editor_instructions"
            );
            quill_editor_set.children[0].innerHTML += this.haccp_description;
          })
          .catch((error) => console.error(error));
      }
    },

    addIngredientRecipeModalOpen() {
      this.addIngredientsModal = true;

      this.search_term = "";
      this.searched_ingredients = [];
    },

    ingredientSearchScriptModal() {
      if (this.search_term == "") {
        this.$toast.error("Error: Search value required!");
      } else {
        let exist_ingredients = [];
        this.rec_ingredients.forEach((value, index) => {
          exist_ingredients.push(value["id"]);
        });
        axios
          .post("/recipe-ingredient-search-modal", {
            term: this.search_term,
            ex_ids: exist_ingredients,
          })
          .then((response) => {
            //console.log(response.data.search_data);
            this.searched_ingredients = response.data;
          })
          .catch((error) => console.error(error));
      }
    },

    async addIngredientAddScript(ing_array, index) {
      this.searched_ingredients.splice(index, 1);

      //ajax to get products related tp selected ingredient
      await axios
        .post("/get_ingredient_prefer_product", {
          ingredient_id: ing_array["id"],
        })
        .then((response) => {
          if (response.data.length > 0) {
            response.data = response.data[0];
          } else {
            //if no prefer product found
            response.data = [];
          }

          let prefer_prod = {};

          prefer_prod["measurement_serving_weight"] =
            response.data["serving_measurement_weight"];
          prefer_prod["measurement_serving_weight_uom"] =
            response.data["serving_measurement_weight_uom_name"];
          prefer_prod["measurement_serving_volume"] =
            response.data["serving_measurement_volume"];
          prefer_prod["measurement_serving_volume_uom"] =
            response.data["serving_measurement_volume_uom_name"];
          prefer_prod["measurement_serving_unit"] =
            response.data["serving_measurement_unit"];
          prefer_prod["measurement_serving_unit_uom"] =
            response.data["serving_measurement_unit_uom_name"];


          prefer_prod["serving_component_weight"] =
            response.data["serving_component_weight"];
          prefer_prod["serving_component_weight_uom"] =
            response.data["serving_component_weight_uom"];
          prefer_prod["serving_component_volume"] =
            response.data["serving_component_volume"];
          prefer_prod["serving_component_volume_uom"] =
            response.data["serving_component_volume_uom"];


          // new calculation added
          prefer_prod['nutrition_facts_weight'] = response.data['nutrition_facts_weight'];
          prefer_prod['nutrition_facts_weight_uom'] = response.data['nutrition_facts_weight_uom_name'];
          prefer_prod['nutrition_facts_volume'] = response.data['nutrition_facts_volume'];
          prefer_prod['nutrition_facts_volume_uom'] = response.data['nutrition_facts_volume_uom_name'];
          prefer_prod['nutrition_facts_unit'] = response.data['nutrition_facts_unit'];
          prefer_prod['nutrition_facts_unit_uom'] = response.data['nutrition_facts_unit_uom_name'];

          // prefer_prod['nutrition_facts_weight'] = response.data['nutrition_facts_weight'];
          // prefer_prod['nutrition_facts_weight_uom'] = response.data['nutrition_facts_weight_uom_name'];
          // prefer_prod['nutrition_facts_volume'] = response.data['nutrition_facts_volume'];
          // prefer_prod['nutrition_facts_volume_uom'] = response.data['nutrition_facts_volume_uom_name'];
          // prefer_prod['nutrition_facts_unit'] = response.data['nutrition_facts_unit'];
          // prefer_prod['nutrition_facts_unit_uom'] = response.data['nutrition_facts_unit_uom_name'];

          prefer_prod["component_mma"] = ing_array["component_mma"] =
            response.data["usda_componenent_serving_meat"];
          prefer_prod["component_wgr"] = ing_array["component_wgr"] =
            response.data["usda_componenent_serving_grain"];
          prefer_prod["component_fru"] = ing_array["component_fru"] =
            response.data["usda_componenent_serving_fruit"];
          prefer_prod["component_mlk"] = ing_array["component_mlk"] =
            response.data["usda_componenent_serving_milk"];
          prefer_prod["component_veg"] = ing_array["component_veg"] =
            response.data["usda_componenent_serving_veg"];
          prefer_prod["component_dg"] = ing_array["component_dg"] =
            response.data["usda_componenent_serving_veggrn"];
          prefer_prod["component_ro"] = ing_array["component_ro"] =
            response.data["usda_componenent_serving_vegred"];
          prefer_prod["component_leg"] = ing_array["component_leg"] =
            response.data["usda_componenent_serving_vegleg"];
          prefer_prod["component_star"] = ing_array["component_star"] =
            response.data["usda_componenent_serving_vegstar"];
          prefer_prod["component_other"] = ing_array["component_other"] =
            response.data["usda_componenent_serving_vegothr"];


          prefer_prod["cuom"] = response.data["cuom"];
          prefer_prod["allergens_name"] = response.data["allergens_name"];

          ing_array["component_nut_calories"] =
            response.data["nutrition_facts_calories"];
          ing_array["component_nut_sodium"] =
            response.data["nutrition_facts_sodium"];
          ing_array["component_nut_totalfat"] =
            response.data["nutrition_facts_totalfat"];
          ing_array["component_nut_protein"] =
            response.data["nutrition_facts_protein"];
          ing_array["component_nut_carbs"] =
            response.data["nutrition_facts_carbs"];

          ing_array["component_nut_added_sugars"] =
            response.data["nutrition_facts_added_sugars"];

          ing_array["component_nut_satfat"] =
            response.data["nutrition_facts_satfat"];

          ing_array["recipe_amount"] = null;
          ing_array["recipe_amount_uom"] = null;

          ing_array["custom_sizing_main_recipe_amount"] = null;
          ing_array["custom_sizing_recipe_amount"] = null;
          ing_array["custom_sizing_recipe_amount_uom"] = null;


          ing_array["serving_amount"] = null;
          ing_array["serving_amount_uom"] = null;

          //setup ingredient components for optional components
          ing_array["optional_component_mma"] = null;
          ing_array["optional_component_wgr"] = null;
          ing_array["optional_component_fru"] = null;
          ing_array["optional_component_mlk"] = null;
          ing_array["optional_component_veg"] = null;
          ing_array["optional_component_dg"] = null;
          ing_array["optional_component_ro"] = null;
          ing_array["optional_component_leg"] = null;
          ing_array["optional_component_star"] = null;
          ing_array["optional_component_other"] = null;


          ing_array["cuom"] = response.data["cuom"];

          ing_array["preferred_product_information"] = prefer_prod;

          console.log("ajax ing_array", ing_array);

          this.ing_prefer_products.push(prefer_prod);

          this.rec_ingredients.push(ing_array);
          this.changeComponentVals(this.rec_ingredients);
        })
        .catch((error) => console.error(error));


    },

    addIngredientsDeleteScript(ingredient_id, click_index) {
      this.rec_ingredients.forEach((value, index) => {
        if (ingredient_id == value["id"]) {
          this.rec_ingredients.splice(index, 1);
        }
      });

      //ajax to delete products related to selected ingredient
      this.ing_prefer_products.splice(click_index, 1);

      this.changeComponentVals(this.rec_ingredients);
    },

    getDataRecipeIngredient(index, event) {
      // console.log(index, '--check updated data-----', event);

      this.rec_ingredients[index]["serving_amount_fractions"] = event["serving_amount_fractions"];
      this.rec_ingredients[index]["recipe_amount_fractions"] = event["recipe_amount_fractions"];


      this.rec_ingredients[index]["recipe_amount"] = event["recipe_amount"];
      this.rec_ingredients[index]["recipe_amount_uom"] =
        event["recipe_amount_uom"];

      this.rec_ingredients[index]["custom_sizing_main_recipe_amount"] = event["custom_sizing_main_recipe_amount"];
      this.rec_ingredients[index]["custom_sizing_recipe_amount"] = event["custom_sizing_recipe_amount"];
      this.rec_ingredients[index]["custom_sizing_recipe_amount_uom"] =
        event["custom_sizing_recipe_amount_uom"];
      this.rec_ingredients[index]["recipe_amount_custom_uom"] = event["recipe_amount_custom_uom"];

      this.rec_ingredients[index]["serving_amount"] = event["serving_amount"];
      this.rec_ingredients[index]["serving_amount_uom"] = event["serving_amount_uom"];
      this.rec_ingredients[index]["serving_amount_custom_uom"] = event["serving_amount_custom_uom"];

      this.rec_ingredients[index]["serving_component_weight"] =
        event["serving_component_weight"];
      this.rec_ingredients[index]["serving_component_weight_uom"] =
        event["serving_component_weight_uom"];

      this.rec_ingredients[index]["serving_component_volume"] =
        event["serving_component_volume"];
      this.rec_ingredients[index]["serving_component_volume_uom"] =
        event["serving_component_volume_uom"];





      this.rec_ingredients[index]["component_mma"] = event["component_mma"];
      this.rec_ingredients[index]["component_wgr"] = event["component_wgr"];
      this.rec_ingredients[index]["component_fru"] = event["component_fru"];
      this.rec_ingredients[index]["component_mlk"] = event["component_mlk"];
      this.rec_ingredients[index]["component_veg"] = event["component_veg"];
      this.rec_ingredients[index]["component_dg"] = event["component_dg"];
      this.rec_ingredients[index]["component_ro"] = event["component_ro"];
      this.rec_ingredients[index]["component_leg"] = event["component_leg"];
      this.rec_ingredients[index]["component_star"] = event["component_star"];
      this.rec_ingredients[index]["component_other"] = event["component_other"];

      this.changeComponentVals(this.rec_ingredients);

      //console.log(this.ing_prefer_products, '--check updated data-----', this.rec_ingredients);
    },

    recipe_add_save_script() {
      var quill_editor = document.querySelector("#quill_editor_instructions");
      // console.log('recipe_add_save_script', this.form);
      // return false;
      if (
        quill_editor.children[0].innerHTML != "" &&
        quill_editor.children[0].innerHTML != "<p><br></p>"
      ) {
        this.form.recipe_instructions = quill_editor.children[0].innerHTML;
      } else {
        this.form.recipe_instructions = "";
      }


      this.form.attached_ingredients = this.rec_ingredients;

      this.form.post(this.route("recipes-add-save"), {
        onSuccess: () => {
          this.$toast.success("Recipe Added Successfully!");
        },
      });
    },
  },
};
</script>

<style scoped>
.suggestions {
  list-style-type: none;
  margin: 0;
  padding: 0;
  border: 1px solid #ccc;
  max-width: 200px;
  position: absolute;
  background-color: white;
  z-index: 10;
}

.suggestions li {
  padding: 8px;
  cursor: pointer;
}

.suggestions li:hover {
  background-color: #f0f0f0;
}
</style>

<style>
.min-height-third {
  min-height: 400px;
}

.w-52-rec {
  width: 13.2rem;
}

.input-background {
  background-color: #f8f8f8;
}

.button-bg-color-wed-menu2-gray {
  border: none !important;
  min-height: 35px;
  min-width: 35px;
}

.menu1-background-color {
  background-color: #faa43d;
}

.button-bg-color-wed-menu2 {
  background-color: #38558e;
  border: none !important;
  min-height: 35px;
  min-width: 35px;
}

.menu1-icon-color {
  color: #38558e;
}

.id-color-menu-edit {
  color: #f7a53a;
}

.bg-button-color {
  background-color: #cb0000;
}

.min-w-min-button {
  min-height: 26px;
  min-width: 53px;
  line-height: 26px;
  text-transform: lowercase;
}

.max-w-0-menu1 {
  max-width: 4rem;
}

.bg-button-color-green {
  background-color: #22af4b;
}

.bg-button-color-gray {
  background-color: #636363;
}

.bg-hard-grey {
  background-color: #f4f4f4;
}

.w-96-edit-recipes {
  width: 35rem;
}

.validation_error_msg {
  font-weight: 400;
  margin: 6px 0 0 !important;
  color: red;
}

@media screen and (min-width: 1500px) {
  .id_arrow .fa-sort-desc:before {
    content: "\f0dd";
    position: absolute;
    top: 16px;
    left: 43px;
    padding-left: 7px;
    color: #219fd5;
  }

  .id_arrow .fa-sort-asc:before {
    content: "\f0de";
    color: #219fd5;
    padding-left: 7px;
    position: absolute;
    top: 16px;
    left: 43px;
  }
}

@media screen and (max-width: 1499px) {
  .id_arrow .fa-sort-asc:before {
    content: "\f0de";
    color: #219fd5;
    padding-left: 7px;
    position: absolute;
    top: 28px;
    left: 43px;
  }

  .id_arrow .fa-sort-desc:before {
    content: "\f0dd";
    position: absolute;
    top: 28px;
    left: 43px;
    padding-left: 7px;
    color: #219fd5;
  }
}

.max-height {
  max-height: 600px;
}

@media (min-width: 640px) {
  .mb-6.bg-white.rounded-lg.overflow-hidden.shadow-xl.transform.transition-all.sm\:w-full.sm\:mx-auto.sm\:max-w-2xl {
    max-width: 60rem;
  }
}

.trim_text {
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 250px;
}

.tooltip {
  display: inline-block;
  position: relative;
  text-align: left;
}

.tooltip .top {
  width: 250px;
  top: 50%;
  left: 100%;
  margin-left: 20px;
  transform: translate(0, -50%);
  padding: 5px 10px;
  color: #444444;
  background-color: #eeeeee;
  font-weight: normal;
  font-size: 14px;
  border-radius: 5px;
  position: absolute;
  z-index: 99999999;
  box-sizing: border-box;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
  display: none;
  white-space: normal;
}

.tooltip:hover .top {
  display: block;
}

.tooltip .top i {
  position: absolute;
  top: 50%;
  right: 100%;
  margin-top: -12px;
  width: 12px;
  height: 24px;
  overflow: hidden;
}

.tooltip .top i::after {
  content: "";
  position: absolute;
  width: 12px;
  height: 12px;
  left: 0;
  top: 50%;
  transform: translate(50%, -50%) rotate(-45deg);
  background-color: #eeeeee;
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
}

.loader-15 {
  background: currentcolor;
  position: relative;
  animation: loader-15 1s ease-in-out infinite;
  animation-delay: 0.4s;
  width: 0.25em;
  height: 0.5em;
  margin: 37px auto;
}

.loader-15:after,
.loader-15:before {
  content: "";
  position: absolute;
  width: inherit;
  height: inherit;
  background: inherit;
  animation: inherit;
}

.loader-15:before {
  right: 0.5em;
  animation-delay: 0.2s;
}

.loader-15:after {
  left: 0.5em;
  animation-delay: 0.6s;
}

@keyframes loader-15 {

  0%,
  100% {
    box-shadow: 0 0 0 currentcolor, 0 0 0 currentcolor;
  }

  50% {
    box-shadow: 0 -0.25em 0 currentcolor, 0 0.25em 0 currentcolor;
  }
}
</style>
